import {FC, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {ISemester, ISemesterMonth} from '../../models/semesters.model'
import {
  doGetSemesters,
  doCreateSemester,
  doUpdateSemester,
  doGetSemesterMonths,
  doCreateSemesterMonths,
  doUpdateSemesterMonths,
  doGetSemesterCourses,
  doCreateSemesterCourses,
  doUpdateSemesterCourses,
  doCreateSemesterInfo
} from '../../store/semester.slice';
import {doGetSteps, doGetCourses} from '../../store/course.slice';
import {doRemoveAuth} from '../../store/auth.slice';
import {RootState} from '../../store/rootReducer';
import moment from 'moment';
import qs from 'qs';
import _ from 'lodash';
import styled from 'styled-components';
import {useSnackbar} from 'notistack';
import {Button as AntButton, Descriptions, Modal, Select, Table, TableColumnsType} from 'antd';

import Loader from '../../components/Loader';
import Header from '../../components/layout/Header';
import Pagination from '../../components/Pagination';
import Footer from '../../components/layout/Footer';
import Button from '../../components/Button';
import config from '../../lib/config';
import {successVariant, infoVariant, warningVariant, errorVariant} from '../../lib/barVariant';
import SemesterInfo from '../../components/program/semester/Info';
import SemesterMonth from '../../components/program/semester/Month';
import SemesterCourse from '../../components/program/semester/Course';
import {doCopyCourseItems, doGetAllSemesterActivities} from '../../store/semesterActivity.slice';
import SemesterSearch from '../../components/program/semester/Search';
import {ISelect} from '../../models/common.model';
import SemesterTable from '../../components/program/semester/Table';
import SemesterEvaluation from '../../components/program/semester/Evaluation';
import ExtendButton from '../../components/ExtendButton';
import SemesterPlan from '../../components/program/semester/Plan';
import useAuth from '../../hooks/useAuth';
import Test from '../../components/program/semester/Test';
import TestEdit from '../../components/program/semester/TestEdit';
import TestRead from '../../components/program/semester/TestRead';
import Level from '../../components/program/semester/Level';

const Block = styled.div`
  .close-left {
    transform: translate(-33%);
  }

  .label-wrapper {
    width: 110px;
  }


  .table-inside {
    width: 100%;

    th {
      background: ghostwhite;
    }
  }

  .table-basic th, td {
    vertical-align: middle;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export enum SemesterContents {
  Info,
  Month,
  Course,
  Plan,
  Evaluation,
  Test,
  TestEdit,
  TestRead,
  Level,
}

const ProgramSemester: FC = () => {
  const {writeAuthYn} = useAuth();
  const { t, i18n } = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const dispatch = useDispatch();
  const {commonCodes} = useSelector((state: RootState) => state.commonCode);
  // PR0001 = 학기구분
  const PR0001 = commonCodes.find(item => item.commonCode === 'PR0001')?.detailCode;
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find(item => item.commonCode === 'PR0002')?.detailCode;
  // SY0005 = 연도
  const SY0005 = commonCodes.find(item => item.commonCode === 'SY0005')?.detailCode;

  const {semesters, months, semesterCourses, isLoading} = useSelector((state: RootState) => state.semester);
  const {steps, courses, stepLoading, courseLoading} = useSelector((state: RootState) => state.course);
  const {copiableCourses, isLoading: activityLoading} = useSelector((state: RootState) => state.semesterActivity);

  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, {ignoreQueryPrefix: true});

  const [isExtended, setIsExtended] = useState(false);
  const [semesterId, setSemesterId] = useState('');
  const [semesterMonths, setSemesterMonths] = useState<any>(null);
  const [semesterCourseData, setSemesterCourseData] = useState<any>(null);
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);
  const [termList, setTermList] = useState<any>(null);
  const [typeList, setTypeList] = useState<any>(null);
  const [year, setYear] = useState('');
  const [yearList, setYearList] = useState<ISelect[]>([]);
  const [name, setName] = useState('');
  const [allSteps, setAllSteps] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [courseList, setCourseList] = useState<any>([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const [param, setParam] = useState({});
  const [page, setPage] = useState(1);
  const [tab, setTab] = useState(SemesterContents.Info);
  const [isCreateMode, setIsCreateMode] = useState(false);

  const semesterInputInit = {
    name: '',
    year: null,
    term: null,
    type: null,
    startDate: null,
    endDate: null,
    regYn: 'N',
    semesterDiv: null,
  };
  const [semesterInput, setSemesterInput] = useState<any>(semesterInputInit);

  const monthInputInit = {
    monthName1: null,
    startDate1: null,
    endDate1: null,
    statsDate1: null,
    monthName2: null,
    startDate2: null,
    endDate2: null,
    statsDate2: null,
    monthName3: null,
    startDate3: null,
    endDate3: null,
    statsDate3: null,
  };
  const [monthInput, setMonthInput] = useState<any>(monthInputInit);

  const courseInputInit = {
    course: null,
    times: [null, null, null]
  };
  const [courseInput, setCourseInput] = useState<any>([]);

  const [timesInputVisible, setTimesInputVisible] = useState(false);
  const [timesIndex, setTimesIndex] = useState(0);
  const [createSemesterInfoVisible, setCreateSemesterInfoVisible] = useState(false);

  // 평가항목 탭에서 사용
  const [chosenCourse, setChosenCourse] = useState<any>(null);

  // 평가항목 복사 모달
  const [copyActivityVisible, setCopyActivityVisible] = useState(false);
  const [copyData, setCopyData] = useState<any>([]);
  const [copyPage, setCopyPage] = useState(1);
  const [sourceCourse, setSourceCourse] = useState<any>(null);
  const [confirmCopyVisible, setConfirmCopyVisible] = useState(false);
  // 검색 dropdown용 state
  const [semester, setSemester] = useState<any>(null);
  const [semesterList, setSemesterList] = useState<any>(null);
  const [level, setLevel] = useState<any>(null);
  const [levelList, setLevelList] = useState<any>(null);

  const [getTestsTrigger, setGetTestsTrigger] = useState(false);
  const [scheduleCode, setScheduleCode] = useState<number>();

  const all = {label: t('common.text.all'), value: 'all'};

  useEffect(() => {
    if (PR0001) {
      const _termList: any = [all];
      const _PR0001 = [...PR0001].sort((a, b) => a.orderSeq < b.orderSeq ? -1 : (a.orderSeq > b.orderSeq ? 1 : 0));
      _PR0001.forEach((item: any) => {
        _termList.push({
          label: `${t('program.semester.option1')}${i18n.language === 'ko' ? item.korName : `${item.engName} `}${t('program.semester.option2')}`,
          value: item.detailCode
        });
      });
      setTermList(_termList);
    }

    if (PR0002) {
      const _typeList: any = [];
      PR0002.forEach((item: any) => {
        _typeList.push({
          label: i18n.language === 'ko' ? item.korName : item.engName,
          value: item.detailCode
        });
      });
      setTypeList(_typeList);
    }

    if (SY0005) {
      const _yearList: any = [all];
      const _SY0005 = _.orderBy(SY0005, ['orderSeq'], ['desc']);
      _SY0005.forEach((item: any) => {
        _yearList.push({
          label: item.korName,
          value: item.detailCode
        });
      });
      setYear('all');
      setYearList(_yearList);
    }
  }, [commonCodes, t]);

  useEffect(() => {
    getSemesters();
    getSteps();
    getCourses();
  }, []);

  useEffect(() => {
    if (semesters && yearList && termList) {
      // query to state
      const _param: any = {};

      if (query.page) {
        setPage(Number(query.page));
        _param.page = Number(query.page);
      }
      if (query.year) {
        setYear(String(query.year));
        _param.year = String(query.year);
      }
      if (query.tab) {
        setTab(Number(query.tab));
        _param.tab = Number(query.tab);
      }

      setParam(_param);

      // data filtering
      let data: ISemester[] = _.cloneDeep(semesters);

      data.forEach((item) => {
        item.semesterDiv = item.semesterDiv.trim();
        item.semesterType = item.semesterType.trim();
      });

      if (query.year) {
        data = data.filter((item: any) => item.learningYearCode === query.year);
      }
      if (query.name) {
        data = data.filter((item: any) => item.semesterName?.indexOf(String(query.name)) !== -1);
      }

      setSemesterData(data);
    }
  }, [location, semesters, yearList, termList]);

  useEffect(() => {
    setSemesterMonths(months);
    const _monthInput: any = {};
    months?.forEach((month, index) => {
      _monthInput[`monthName${index + 1}`] = month.monthName;
      _monthInput[`startDate${index + 1}`] = month.monthSrtDate ? moment(month.monthSrtDate).format('YYYY-MM-DD') : '';
      _monthInput[`endDate${index + 1}`] = month.monthEndDate ? moment(month.monthEndDate).format('YYYY-MM-DD') : '';
      _monthInput[`statsDate${index + 1}`] = month.statsDate ? moment(month.statsDate).format('YYYY-MM-DD') : '';
    });
    setMonthInput(_monthInput);
  }, [months]);

  useEffect(() => {
    setSemesterCourseData(semesterCourses);
    const _courseInput: any = [];
    semesterCourses?.forEach((course, index) => {
      const obj: any = {};
      obj.id = course.semesterCourseCode;
      obj.course = course.courseDetailCode;
      const times: any = [];
      course.months.forEach(time => times.push({
        label: time.lessonCount,
        value: time.lessonCount
      }));
      obj.times = times;
      _courseInput.push(obj);
    });
    setCourseInput(_courseInput);
  }, [semesterCourses]);

  useEffect(() => {
    if (steps) {
      const _allSteps: any = [];
      steps.forEach(level => {
        level.step?.forEach(step => {
          _allSteps.push({
            levelCode: level.courseCode,
            levelName: level.courseName,
            stepCode: step.courseCode,
            stepName: step.courseName,
          });
        })
      });
      setAllSteps(_allSteps);
    }
  }, [steps]);

  useEffect(() => {
    if (courses && allSteps.length > 0) {
      let data: any = _.cloneDeep(courses);
      const _courseList: any = [];

      data.forEach((item: any) => {
        if (item.useYn === 'Y') {
          _courseList.push({
            label: item.courseDetailName,
            value: item.courseDetailCode,
            courseCode: item.courseCode
          });

          const step: any = allSteps?.find((step: any) => step.stepCode === item.courseCode);
          if (step) {
            item.levelCode = step.levelCode;
            item.levelName = step.levelName;
            item.stepCode = step.stepCode;
            item.stepName = step.stepName;
          }
          item.curriculumType = item.curriculumType.trim();
        }
      });

      setCourseList(_courseList);
      setCourseData(data);
    }
  }, [courses, allSteps]);

  useEffect(() => {
    if (copiableCourses) {
      const list1: any = [];
      const list2: any = [];
      copiableCourses.forEach((item: any) => {
        list1.push({
          label: item.semesterName,
          value: item.semesterCode
        });
        list2.push(item.levelName);
      });

      setSemesterList(_.uniqBy(list1, 'value'));
      setLevelList(_.uniq(list2));
      setCopyData(copiableCourses);
    }
  }, [copiableCourses]);

  useEffect(() => {
    if (tab === SemesterContents.TestEdit ||
      tab === SemesterContents.TestRead) {
      setTab(SemesterContents.Test);
    }
  }, [semesterId]);

  const onSetTab = (_tab: number) => {
    const _param = {...param, tab: _tab};
    history.push(`/program/semester?${qs.stringify(_param)}`);
  }

  const getSemesters = async () => {
    const res = await dispatch(doGetSemesters());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getSteps = async () => {
    const res = await dispatch(doGetSteps());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getCourses = async () => {
    const res = await dispatch(doGetCourses());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSearch = () => {
    const param: any = {page: 1, tab};

    if (year !== 'all') {
      param.year = year;
    }
    if (name) {
      param.name = name;
    }

    setParam(param);
    history.push(`/program/semester?${qs.stringify(param)}`);
  }

  const onCreate = () => {
    setSemesterId('');
    setSemesterInput(semesterInputInit);
    setMonthInput(monthInputInit);
    setSemesterMonths(null);
    setIsCreateMode(true);
    setIsDisabled(false);
    onSetTab(SemesterContents.Info);
  }

  const onSetSemester = (id: string) => {
    const semester = semesters?.find((item: any) => item.semesterCode === id);
    if (semester) {
      setSemesterId(id);
      fillSemesterInput(semester);
      setIsCreateMode(false);
      setIsDisabled(semester.regYn === 'Y');
    }
  }

  const fillSemesterInput = (semester: ISemester) => {
    const name = semester.semesterName;
    const year = yearList.find((item: any) => item.value === semester.learningYearCode)?.value;
    const term = termList.find((item: any) => item.value === semester.semesterDiv)?.value;
    const type = typeList.find((item: any) => item.value === semester.semesterType.trim())?.value;
    const startDate = semester.semesterSrtDate;
    const endDate = semester.semesterEndDate;
    const regYn = semester.regYn ? semester.regYn : 'N';
    const semesterDiv = semester.semesterDiv;

    setSemesterInput({
      name,
      year,
      term,
      type,
      startDate: `${startDate.slice(0, 4)}-${startDate.slice(4, 6)}-${startDate.slice(6)}`,
      endDate: `${endDate.slice(0, 4)}-${endDate.slice(4, 6)}-${endDate.slice(6)}`,
      regYn,
      semesterDiv
    });
  }


  const onSetCourseInput = (index: number, key: string, value: any) => {
    const _courseInput = [...courseInput];
    _courseInput[index] = {..._courseInput[index], [key]: value};
    _courseInput[index].times = [null, null, null];
    setCourseInput(_courseInput);
  }

  const onSetCourseTimes = (index: number, e: any) => {
    const _courseInput = [...courseInput];
    _courseInput[timesIndex].times[index] = e;
    setCourseInput(_courseInput);
  }

  const renderCourseInfo = (courseId: number, key: string) => {
    const course = courseData?.find((item: any) => item.courseDetailCode === courseId);

    if (course) return course[key];
    else return '-';
  }

  const onAddCourse = () => {
    // 임시해제
    // if (isDisabled) return;
    setCourseInput([...courseInput, courseInputInit]);
  }

  const onDeleteCourse = (index: number) => {
    const _courseInput = [...courseInput];
    _courseInput.splice(index, 1);
    setCourseInput(_courseInput);
  }

  const onSubmit = () => {
    // 임시해제
    // if (isDisabled && tab !== SemesterContents.Month) {
    //   return;
    // }

    switch (tab) {
      case SemesterContents.Info:
        onSubmitSemester();
        break;
      case SemesterContents.Month:
        onSubmitSemesterMonths();
        break;
      case SemesterContents.Course:
        onSubmitSemesterCourse();
    }
  }

  const onSubmitSemester = async () => {
    const {name, year, term, type, startDate, endDate, regYn} = semesterInput;

    if (regYn === 'Y') {
      return enqueueSnackbar(t('program.semester.message1'), infoVariant);
    }
    if (!name) {
      return enqueueSnackbar(t('program.semester.message2'), infoVariant);
    }
    if (!year) {
      return enqueueSnackbar(t('program.semester.message3'), infoVariant);
    }
    if (!term) {
      return enqueueSnackbar(t('program.semester.message4'), infoVariant);
    }
    if (!type) {
      return enqueueSnackbar(t('program.semester.message5'), infoVariant);
    }
    if (!startDate) {
      return enqueueSnackbar(t('program.semester.message6'), infoVariant);
    }
    if (!endDate) {
      return enqueueSnackbar(t('program.semester.message7'), infoVariant);
    }

    if (moment(startDate).isAfter(endDate)) {
      return enqueueSnackbar(t('program.semester.message8'), infoVariant);
    }

    const req = {
      learningYearCode: year,
      semesterName: name,
      semesterDiv: term,
      semesterType: type,
      semesterSrtDate: moment(startDate).format('YYYYMMDD'),
      semesterEndDate: moment(endDate).format('YYYYMMDD')
    };

    const res = isCreateMode
      ? await dispatch(doCreateSemester(req))
      : await dispatch(doUpdateSemester(semesterId, req));
    const message = isCreateMode
      ? t('common.message.create')
      : t('common.message.edit1');

    switch (res?.status) {
      case 200:
        enqueueSnackbar(message, successVariant);
        setSemesterId(res.data.data.semesterCode);
        getSemesters();
        setIsCreateMode(false);
        break;
      case 400:
        enqueueSnackbar(t('program.semester.message9'), warningVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmitSemesterMonths = async () => {
    const {
      monthName1,
      startDate1,
      endDate1,
      statsDate1,
      monthName2,
      startDate2,
      endDate2,
      statsDate2,
      monthName3,
      startDate3,
      endDate3,
      statsDate3
    } = monthInput;
    const isUpdate = semesterMonths?.length > 0;

    if (!monthName1 || !monthName2 || !monthName3) {
      return enqueueSnackbar(t('program.semester.message10'), infoVariant);
    }
    if (!startDate1 || !startDate2 || !startDate3 || !endDate1 || !endDate2 || !endDate3 || !statsDate1 || !statsDate2 || !statsDate3) {
      return enqueueSnackbar(t('program.semester.message11'), infoVariant);
    }
    if (monthName1 === monthName2 || monthName1 === monthName3 || monthName2 === monthName3) {
      return enqueueSnackbar(t('program.semester.message12'), infoVariant);
    }
    const totalDays = moment(startDate1).diff(endDate3, 'days');
    const sumDays = moment(startDate1).diff(endDate1, 'days') + moment(startDate2).diff(endDate2, 'days') + moment(startDate3).diff(endDate3, 'days') - 2;
    if (totalDays !== sumDays) {
      return enqueueSnackbar(t('program.semester.message13'), infoVariant);
    }

    const req: ISemesterMonth[] = [
      {
        monthName: monthName1,
        monthSrtDate: moment(startDate1).format('YYYYMMDD'),
        monthEndDate: moment(endDate1).format('YYYYMMDD'),
        statsDate: moment(statsDate1).format('YYYYMMDD'),
      },
      {
        monthName: monthName2,
        monthSrtDate: moment(startDate2).format('YYYYMMDD'),
        monthEndDate: moment(endDate2).format('YYYYMMDD'),
        statsDate: moment(statsDate2).format('YYYYMMDD'),
      },
      {
        monthName: monthName3,
        monthSrtDate: moment(startDate3).format('YYYYMMDD'),
        monthEndDate: moment(endDate3).format('YYYYMMDD'),
        statsDate: moment(statsDate3).format('YYYYMMDD'),
      },
    ];

    if (isUpdate) {
      req.forEach((item, index) => {
        item.monthSeq = semesterMonths[index].monthSeq;
      });
    }

    const res = isUpdate
      ? await dispatch(doUpdateSemesterMonths(semesterId, req))
      : await dispatch(doCreateSemesterMonths(semesterId, req));
    const message = isUpdate
      ? t('common.message.edit1')
      : t('common.message.create1');

    switch (res.status) {
      case 200:
        enqueueSnackbar(message, successVariant);
        setSemesterMonths(res.data.data);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmitSemesterCourse = async () => {
    let isBroken = false;
    courseInput.forEach((item: any, index: number) => {
      if (!item.course) {
        return enqueueSnackbar(t('program.semester.message14'), infoVariant);
      }
      for (let i = 0; i < item.times.length; i++) {
        if (item.times[i] === null) {
          isBroken = true;
          return enqueueSnackbar(`${t('program.semester.message15')}${index + 1}${t('program.semester.message16')}`, infoVariant);
        }
      }
    });
    if (isBroken) return;

    const isUpdate = semesterCourseData?.length > 0;
    const req: any = [];
    const updateReq: any = [];

    courseInput.forEach((input: any) => {
      const obj: any = {};
      const course: any = courseData?.find((item: any) => item.courseDetailCode === input.course);
      if (!course) return;

      obj.semesterCode = semesterId;
      obj.courseDetailCode = input.course;
      obj.weekLectureCount = course.weekLectureCount;
      obj.dayLessonCount = course.dayLessonCount;
      obj.lessonTime = course.lessonTime;
      obj.onlineTuition = course.onlineTuition;
      obj.alexTuition = course.alexTuition;
      obj.months = [];
      input.times.forEach((time: any, index: number) => {
        obj.months.push({
          monthSeq: semesterMonths[index].monthSeq,
          lessonCount: time.value || time
        });
      });

      if (input.id) {
        obj.semesterCourseCode = input.id;
        obj.delYn = 'N';
        updateReq.push(obj);
      } else {
        req.push(obj);
      }
    });

    if (isUpdate) {
      // delete
      semesterCourseData.forEach((course: any) => {
        const id = course.semesterCourseCode;
        const isExist = courseInput.find((item: any) => item.id && item.id === id);
        if (!isExist) {
          updateReq.push({...course, delYn: 'Y'});
        }
      });

      // update
      const res = await dispatch(doUpdateSemesterCourses(updateReq));

      switch (res.status) {
        case 200:
          setSemesterCourseData(semesterCourseData.concat(res.data.data));
          dispatch(doGetSemesterCourses(semesterId));
          break;
        case 401:
          dispatch(doRemoveAuth());
          break;
        case 403:
          enqueueSnackbar(t('common.message.forbidden'), warningVariant);
          history.push('/');
          break;
        default:
          enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
      }
    }

    // create
    {
      const res = await dispatch(doCreateSemesterCourses(req));
      const message = isUpdate
        ? t('common.message.edit1')
        : t('common.message.create');

      switch (res.status) {
        case 200:
          enqueueSnackbar(message, successVariant);
          setSemesterCourseData(semesterCourseData.concat(res.data.data));
          dispatch(doGetSemesterCourses(semesterId));
          break;
        case 401:
          dispatch(doRemoveAuth());
          break;
        case 403:
          enqueueSnackbar(t('common.message.forbidden'), warningVariant);
          history.push('/');
          break;
        default:
          enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
      }
    }
  }

  const onCancel = () => {
    setSemesterId('');
    setSemesterInput(semesterInputInit);
    setSemesterMonths(null);
    setIsCreateMode(false);
    onSetTab(SemesterContents.Info);
  }

  const getSemesterMonths = async (code = semesterId) => {
    const res = await dispatch(doGetSemesterMonths(code));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getSemesterCourses = async (id = semesterId) => {
    const res = await dispatch(doGetSemesterCourses(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getTimeList = (index: number) => {
    if (!courseInput[index].course) return;

    const course: any = courseData?.find((item: any) => item.courseDetailCode === courseInput[index].course);
    if (course) {
      const count = course.weekLectureCount;
      return [
        {label: count * 4, value: count * 4},
        // { label: count * 4 + 1, value: count * 4 + 1 }
      ];
    } else {
      return [];
    }
  }

  const onSetCreateSemesterInfo = async () => {
    setCreateSemesterInfoVisible(false);

    const res = await dispatch(doCreateSemesterInfo(semesterId));

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        setSemesterInput({...semesterInput, regYn: 'Y'});
        setIsDisabled(true);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getAllSemesterActivities = async (index: number | null = null) => {
    if (!chosenCourse) return;

    const semesterCourseCode = courseInput[index === null ? chosenCourse : index].id;
    const res = await dispatch(doGetAllSemesterActivities(semesterCourseCode));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSearchCopiableCourses = (semester: any, level: any) => {
    let data: any = _.cloneDeep(copiableCourses);

    if (semester && semester !== 'all') {
      data = data.filter((item: any) => item.semesterCode === semester);
    }
    if (level && level !== 'all') {
      data = data.filter((item: any) => item.levelName === level);
    }

    setCopyData(data);
  }

  const copyActivityColumns: TableColumnsType<any> = [
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
      sorter: (a, b) => a.semesterName?.localeCompare(b.semesterName),
    },
    {
      title: t('program.semester.column1'),
      dataIndex: 'courseDetailName',
      key: 'courseDetailName',
      align: 'center',
      sorter: (a, b) => a.courseDetailName?.localeCompare(b.courseDetailName),
    },
    {
      title: t('program.semester.column2'),
      dataIndex: 'levelName',
      key: 'levelName',
      align: 'center',
      sorter: (a, b) => a.levelName?.localeCompare(b.levelName),
    },
    {
      title: t('program.semester.column3'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
      sorter: (a, b) => a.courseName?.localeCompare(b.courseName),
    },
    {
      title: t('program.semester.column4'),
      dataIndex: 'weekLectureCount',
      key: 'weekLectureCount',
      align: 'center',
      sorter: (a, b) => a.weekLectureCount?.localeCompare(b.weekLectureCount),
    },
    {
      title: '',
      dataIndex: 'semesterCourseCode',
      key: 'semesterCourseCode',
      align: 'center',
      render: (value, record) => (
        <Button
          className="btn btn-sm btn-success btn-w50p"
          onClick={() => {
            setSourceCourse(record);
            setConfirmCopyVisible(true);
          }}
          text={t('program.semester.button1')}
        />
      )
    }
  ];

  const onCopyCourseItems = async () => {
    const semesterCourseCode = courseInput[chosenCourse].id;
    const targetSemesterCourseCode = sourceCourse.semesterCourseCode;
    const res = await dispatch(doCopyCourseItems(semesterCourseCode, targetSemesterCourseCode));

    switch (res?.status) {
      case 200:
        getAllSemesterActivities();
        setConfirmCopyVisible(false);
        setCopyActivityVisible(false);
        enqueueSnackbar(t('program.semester.message17'), successVariant);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const getCourseName = (courseValue: number) => {
    return courseList.find((item: any) => item.value === courseValue)?.label || courseValue;
  }

  const getCourseLabel = () => sessionStorage.getItem('courseLabel');

  const getChosenCourseList = () => {
    const chosenCourseList: any = [];

    for (let i = 0; i < courseInput.length; i++) {
      if (!courseInput[i].id) continue;
      const courseDetailCode = courseInput[i].course;
      const course = courseList.find((item: any) => item.value === courseDetailCode);
      // 교육과정 목록 생성
      chosenCourseList.push({
        label: course?.label,
        value: i,
        courseCode: course?.courseCode
      });
    }

    return chosenCourseList;
  }

  const renderTabContent = () => {
    switch (tab) {
      case SemesterContents.Info:
        return (
          <SemesterInfo
            yearList={yearList}
            termList={termList}
            typeList={typeList}
            semesterInput={semesterInput}
            setSemesterInput={setSemesterInput}
            isDisabled={isDisabled}
          />
        );
      case SemesterContents.Month:
        return (
          <SemesterMonth
            monthInput={monthInput}
            setMonthInput={setMonthInput}
            isDisabled={isDisabled}
          />
        );
      case SemesterContents.Course:
        return (
          <SemesterCourse
            courseInput={courseInput}
            courseList={courseList}
            onSetCourseInput={onSetCourseInput}
            renderCourseInfo={renderCourseInfo}
            onDeleteCourse={onDeleteCourse}
            isDisabled={isDisabled}
            setTimesIndex={setTimesIndex}
            setTimesInputVisible={setTimesInputVisible}
          />
        );
      case SemesterContents.Plan: {
        const chosenCourseList = getChosenCourseList();

        return (
          <SemesterPlan
            courseInput={courseInput}
            chosenCourseList={chosenCourseList}
          />
        );
      }
      case SemesterContents.Evaluation: {
        const chosenCourseList = getChosenCourseList();

        return (
          <SemesterEvaluation
            chosenCourseList={chosenCourseList}
            semesterInput={semesterInput}
            courseInput={courseInput}
          />
        );
      }
      case SemesterContents.Test:
        return (
          <Test
            semesterCode={semesterId}
            setTab={setTab}
            getTestsTrigger={getTestsTrigger}
            setScheduleCode={setScheduleCode}
          />
        );
      case SemesterContents.TestEdit:
        return (
          <TestEdit
            semesterCode={semesterId}
            setTab={setTab}
            setGetTestsTrigger={setGetTestsTrigger}
            scheduleCode={scheduleCode}
          />
        );
      case SemesterContents.TestRead:
        return (
          <TestRead
            scheduleCode={scheduleCode}
            setTab={setTab}
            setGetTestsTrigger={setGetTestsTrigger}
          />
        );
      case SemesterContents.Level:
        return (
          <Level
            semesterCode={semesterId}
            semesterStartDate={semesterInput.startDate}
          />
        );
    }
  }

  return (
    <Block className="content-wrapper">
      {isLoading || stepLoading || courseLoading || activityLoading ? <Loader/> : null}
      <Header
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('program.semester.title1')}
        iconFile="icon-program-big.svg"
      />
      <div className={'main flex transition' + (isExtended ? ' close-left' : '')}>
        {/* Left Side */}
        <div className="col-4">
          <SemesterSearch
            year={year}
            setYear={setYear}
            yearList={yearList}
            name={name}
            setName={setName}
            onSearch={onSearch}
          />
          <SemesterTable
            semesters={semesters}
            semesterData={semesterData}
            monthInputInit={monthInputInit}
            setMonthInput={setMonthInput}
            onSetSemester={onSetSemester}
            getSemesterMonths={getSemesterMonths}
            getSemesterCourses={getSemesterCourses}
            setChosenCourse={setChosenCourse}
            param={param}
            page={page}
          />
        </div>

        {/* Right Side */}
        <div className={'transition ' + (isExtended ? 'col-12' : 'col-8')}>
          <div className="mb-3 row">
            <div className="col-6">
              <ExtendButton
                isExtended={isExtended}
                setIsExtended={setIsExtended}
              />
            </div>
            <div className="col-6 pt-2 text-right">
              <Button
                className='btn btn-primary btn-w100p'
                onClick={onCreate}
                text={t('program.semester.button2')}
                writeAuthYn={writeAuthYn}
              />
            </div>
          </div>
          <div>
            <div className="card card-tabs">
              <div className="card-header p-0 pt-1 border-bottom-0">
                <ul className="nav nav-tabs" id="custom-tabs-tab" role="tablist">
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (tab === SemesterContents.Info ? ' active' : '')}
                      onClick={() => onSetTab(SemesterContents.Info)}
                    >
                      {t('program.semester.tab1')}
                    </a>
                  </li>
                  {/* 기본정보 있을 시에만 활성화 */}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (tab === SemesterContents.Month ? ' active' : '') + (semesterId ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Month)}
                    >
                      {t('program.semester.tab2')}
                    </a>
                  </li>
                  {/* 기본정보 + 월 설정 있을 시에만 활성화*/}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (tab === SemesterContents.Course ? ' active' : '') + (semesterId && semesterMonths?.length > 0 ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Course)}
                    >
                      {t('program.semester.tab3')}
                    </a>
                  </li>
                  {/* 수업 계획 */}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (tab === SemesterContents.Plan ? ' active' : '') + (semesterId ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Plan)}
                    >
                      {t('program.semester.tab4')}
                    </a>
                  </li>
                  {/* 평가 관리 */}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (tab === SemesterContents.Evaluation ? ' active' : '') + (semesterId ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Evaluation)}
                    >
                      {t('program.semester.tab5')}
                    </a>
                  </li>
                  {/* 시험 관리 */}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (
                        tab === SemesterContents.Test ||
                        tab === SemesterContents.TestEdit ||
                        tab === SemesterContents.TestRead
                          ? ' active'
                          : ''
                      ) + (semesterId ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Test)}
                    >
                      {t('program.semester.tab6')}
                    </a>
                  </li>
                  {/* 레벨업 관리 */}
                  <li className="nav-item">
                    <a
                      className={'nav-link' + (
                        tab === SemesterContents.Level
                          ? ' active'
                          : ''
                      ) + (semesterId ? '' : ' disabled')}
                      onClick={() => onSetTab(SemesterContents.Level)}
                    >
                      {t('program.semester.tab7')}
                    </a>
                  </li>
                </ul>
              </div>
              <div className="card-body">
                <div className="tab-content" id="custom-tabs-tabContent">
                  {
                    isCreateMode || semesterId
                      ? (
                        <div>
                          {renderTabContent()}
                        </div>
                      )
                      : (
                        <div className="text-center">
                          {t('program.semester.text1')}
                        </div>
                      )
                  }
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-6">
                {
                  !isDisabled &&
                  tab === SemesterContents.Info &&
                  semesterCourses &&
                  semesterCourses.length > 0 &&
                  semesterId
                    ? (
                      <Button
                        className='btn btn-info mr-1 btn-w150p'
                        onClick={() => setCreateSemesterInfoVisible(true)}
                        text={t('program.semester.button3')}
                      />
                    )
                    : null
                }
                {
                  tab === SemesterContents.Course
                    ? (
                      <Button
                        className='btn btn-info btn-w100p ml-2'
                        onClick={onAddCourse}
                        text={t('program.semester.button4')}
                        // 임시해제
                        // disabled={isDisabled}
                      />
                    )
                    : null
                }
              </div>
              <div className="col-6 text-right">
                {/* 임시해제 - 저장 추가 */}
                {/* {((!isDisabled || tab === SemesterContents.Month) && (isCreateMode || semesterId)) && */}
                <Button
                  className='btn btn-primary mr-1 btn-w100p'
                  onClick={onSubmit}
                  text={t('common.button.save')}
                  writeAuthYn={writeAuthYn}
                />
                {/* } */}
                {(isCreateMode || semesterId) &&
                  <Button
                    className='btn btn-secondary btn-w100p'
                    onClick={onCancel}
                    text={t('common.button.cancel')}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer/>

      {/* 차시정보 입력 모달 */}
      <Modal
        title={t('program.semester.title2')}
        visible={timesInputVisible}
        onCancel={() => setTimesInputVisible(false)}
        width={400}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => setTimesInputVisible(false)}
            >
              {t('common.button.confirm')}
            </AntButton>
          </div>
        ]}
      >
        {
          courseInput[timesIndex]
            ? (
              <Descriptions
                bordered
                column={1}
                size="small"
                labelStyle={{textAlign: 'center'}}
              >
                <Descriptions.Item label={t('program.semester.column5')}>
                  {getCourseName(courseInput[timesIndex].course)}
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column6')}>
                  <Select
                    className="w-100"
                    placeholder={t('common.button.select')}
                    value={courseInput[timesIndex].times[0]}
                    onChange={value => onSetCourseTimes(0, value)}
                    // 임시해제
                    // disabled={isDisabled}
                  >
                    {
                      getTimeList(timesIndex)?.map((item: any) => {
                        return (
                          <Select.Option
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column7')}>
                  <Select
                    className="w-100"
                    placeholder={t('common.button.select')}
                    value={courseInput[timesIndex].times[1]}
                    onChange={value => onSetCourseTimes(1, value)}
                    // 임시해제
                    // disabled={isDisabled}
                  >
                    {
                      getTimeList(timesIndex)?.map((item: any) => {
                        return (
                          <Select.Option
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Descriptions.Item>
                <Descriptions.Item label={t('program.semester.column8')}>
                  <Select
                    className="w-100"
                    placeholder={t('common.button.select')}
                    value={courseInput[timesIndex].times[2]}
                    onChange={value => onSetCourseTimes(2, value)}
                    // 임시해제
                    // disabled={isDisabled}
                  >
                    {
                      getTimeList(timesIndex)?.map((item: any) => {
                        return (
                          <Select.Option
                            key={item.value}
                            value={item.value}
                          >
                            {item.label}
                          </Select.Option>
                        )
                      })
                    }
                  </Select>
                </Descriptions.Item>
              </Descriptions>
            )
            : null
        }
      </Modal>

      {/* 학기정보 생성 모달 */}
      <Modal
        title={t('program.semester.button3')}
        visible={createSemesterInfoVisible}
        onCancel={() => setCreateSemesterInfoVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onSetCreateSemesterInfo}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setCreateSemesterInfoVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        {t('program.semester.text2')}<br/>
        {`(${t('program.semester.text3')})`}
      </Modal>

      {/* 평가항목 복사 모달 */}
      <Modal
        title={`${t('program.semester.title3')} - ${getCourseLabel()}`}
        visible={copyActivityVisible}
        onCancel={() => setCopyActivityVisible(false)}
        width={700}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setCopyActivityVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-end mb-2">
          <div className="mr-1 w-150p">
            <Select
              className="w-100"
              placeholder={t('common.column.semester')}
              onChange={(value) => {
                setSemester(value);
                onSearchCopiableCourses(value, level);
              }}
            >
              <Select.Option value="all">{t('common.text.all')}</Select.Option>
              {
                semesterList?.map((item: any) => {
                  return (
                    <Select.Option
                      key={item.value}
                      value={item.value}
                    >
                      {item.label}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </div>
          <div className="mr-1 w-150p">
            <Select
              className="w-100"
              placeholder={t('program.semester.column2')}
              onChange={(value) => {
                setLevel(value);
                onSearchCopiableCourses(semester, value);
              }}
            >
              <Select.Option value="all">{t('common.text.all')}</Select.Option>
              {
                levelList?.map((item: any) => {
                  return (
                    <Select.Option
                      key={item}
                      value={item}
                    >
                      {item}
                    </Select.Option>
                  )
                })
              }
            </Select>
          </div>
        </div>
        <div>
          <Table
            columns={copyActivityColumns}
            dataSource={copyData || undefined}
            pagination={{
              current: copyPage,
              pageSize: config.miniPageSize
            }}
          />
        </div>
        <div>
          <Pagination
            count={copyData?.length || 0}
            page={copyPage}
            setPage={setCopyPage}
            mini
          />
        </div>
      </Modal>

      {/* 평가항목 복사 확인 모달 */}
      <Modal
        title={t('program.semester.title4')}
        visible={confirmCopyVisible}
        onCancel={() => setConfirmCopyVisible(false)}
        width={400}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => {
                onCopyCourseItems();
              }}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setConfirmCopyVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div>
          {t('program.semester.text13')}"{sourceCourse?.courseDetailName}"{t('program.semester.text4')}<br/>
          {t('program.semester.text5')}"{chosenCourse?.label}"{t('program.semester.text6')}
        </div>
      </Modal>
    </Block>
  )
}

export default ProgramSemester;
